import axios from "axios";
import { cookies } from "./cookie";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "http://localhost:4000",
  withCredentials: true,
});

// Request: access token нэмэх
api.interceptors.request.use(
  function (config) {
    const token = cookies.get("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.withCredentials = true;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Эдгээр дээр 401 ирвэл refresh хийхгүй
const AUTH_SKIP = [
  "/api/admin/auth/login",
  "/api/admin/auth/refresh",
  "/api/admin/auth/logout",
];

// Нэг зэрэг олон 401 ирвэл ганц refresh явуулна (rotation-оос болж эвдрэхээс сэргийлнэ)
let refreshPromise = null;

const refreshAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(
        `${api.defaults.baseURL}/api/admin/auth/refresh`,
        {},
        { withCredentials: true },
      )
      .then((res) => {
        const token = res.data.data.access_token;
        cookies.set("access_token", token, { path: "/" });
        return token;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

// Response: 401 → refresh → дахин оролдох
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const skip = AUTH_SKIP.some((u) => original?.url?.includes(u));

    if (status === 401 && original && !original._retry && !skip) {
      original._retry = true;
      try {
        const token = await refreshAccessToken();
        original.headers["Authorization"] = `Bearer ${token}`;
        return api(original);
      } catch (err) {
        cookies.remove("access_token", { path: "/" });
        // /login дээр байхад дахин ачаалбал loop болно
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);

const POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  URLENCODED = "urlencoded",
  FORMDATA = "formdata",
  JSONDATA = "json";

export default function apiRequest(
  method,
  url,
  data,
  contenttype,
  onUploadProgress,
) {
  let ct;
  if (contenttype === URLENCODED) ct = "application/x-www-form-urlencoded";
  if (contenttype === FORMDATA) ct = "multipart/form-data";
  if (contenttype === JSONDATA) ct = "application/json";

  const config = {
    headers: { ...(ct && { "content-type": ct }) },
    withCredentials: true,
    ...(onUploadProgress && { onUploadProgress }),
  };

  if (method === GET) {
    return api
      .get(url, {
        ...config,
        ...(data && { params: data }),
      })
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === POST) {
    return api
      .post(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === PUT) {
    return api
      .put(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === PATCH) {
    return api
      .patch(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === DELETE) {
    return api
      .delete(url, {
        ...config,
        data,
      })
      .then((res) => res)
      .catch((err) => err.response);
  }
}
